import { initVehicleSelectWidget, setCookie, removeCookie } from "../utils/fn";

export const m1FindVehicleUs = async () => {
  const widgets = document.querySelectorAll('.m1-find-vehicle-us:not(.initialized)');

  widgets.forEach((widget) => {
    const parentVehicleWidget = widget.closest('.m1-find-vehicle-us');
    const form = widget.querySelector('form');

    widget.addEventListener('click', (event) => {
      const target = event.target.closest('.m1-find-vehicle-us_toggle-button, .m1-find-vehicle-us_toggle-title');
      if (!target) return;

      const isCollapsed = widget.classList.contains('collapsed');
      const smallWrapper = widget.querySelector('.m1-find-vehicle-us_small-wrapper');
      const bigWrapper = widget.querySelector('.m1-find-vehicle-us_big-wrapper');
      const vehicleTypes = widget.nextElementSibling;

      if (isCollapsed) {
        widget.classList.remove('collapsed');
        smallWrapper.style.display = 'none';
        bigWrapper.style.display = 'block';
        vehicleTypes.style.display = 'block';
        setCookie('find_vehicle_expanded', 1, 365);
      } else {
        widget.classList.add('collapsed');
        smallWrapper.style.display = 'block';
        bigWrapper.style.display = 'none';
        vehicleTypes.style.display = 'none';
        removeCookie('find_vehicle_expanded');
      }
    });

    widget.addEventListener('click', (event) => {
      if (event.target.matches('.m1-find-vehicle-us_type-switcher input')) {
        widget.classList.toggle('show-used');
      }
    });

    form.addEventListener('submit', function (event) {
      event.preventDefault();

      gtmDataLayer.push({ event: 'findVehicleSubmit' });

      const formData = new FormData(form);
      const params = new URLSearchParams(formData).entries();
      const data = {};
      
      for (const [key, value] of params) {
        if (value.trim()) data[key] = value;
      }

      let url;
      if (!data.year && form.dataset.cseType === 'oem') {
        url = `/${data.make?.split('_')[1]}/${data.model?.split('_')[1] || ''}/`;
      } else {
        url = form.getAttribute('action') + '?with_images=true&' + new URLSearchParams(data).toString();
      }

      window.location.href = url;
    });

    if(!parentVehicleWidget.classList.contains('initialized')) {
      initVehicleSelectWidget(widget, i18n, parentVehicleWidget.classList.contains('initialized'));
    };
    // Initialize vehicle selection widget

    parentVehicleWidget.classList.add('initialized');
  });
};